var React = require('react');

function Add18 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 1V8H17V10H10V17H8V10H1V8H8V1H10Z","fill":"currentColor"}));
}

Add18.defaultProps = {"width":"18","height":"18","viewBox":"0 0 18 18","fill":"none"};

module.exports = Add18;

Add18.default = Add18;
